module.exports = __webpack_public_path__ + "static/media/max.b38d001f.jpg";